module.exports = __webpack_public_path__ + "img/banner0.a338ba88.png";